import * as t from 'io-ts';
import { updateObject } from './generics';
export const EventV = t.intersection([
    t.type({
        id: t.number,
        category: t.string,
        description: t.string,
        organization: t.union([t.string, t.null]),
        meta: t.record(t.string, t.any),
        tag: t.string,
    }),
    t.partial({
        user_event: t.boolean,
        command: t.union([t.number, t.null]),
        end_user: t.string,
        session: t.string,
        created: t.string,
    }),
], 'Event');
export class Event {
}
Event.update = updateObject(EventV, EventV, 'events');
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZXZlbnQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvbWlkZGxld2FyZS9ldmVudC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxLQUFLLENBQUMsTUFBTSxPQUFPLENBQUM7QUFDM0IsT0FBTyxFQUFFLFlBQVksRUFBRSxNQUFNLFlBQVksQ0FBQztBQUUxQyxNQUFNLENBQUMsTUFBTSxNQUFNLEdBQUcsQ0FBQyxDQUFDLFlBQVksQ0FDbEM7SUFDRSxDQUFDLENBQUMsSUFBSSxDQUFDO1FBQ0wsRUFBRSxFQUFFLENBQUMsQ0FBQyxNQUFNO1FBQ1osUUFBUSxFQUFFLENBQUMsQ0FBQyxNQUFNO1FBQ2xCLFdBQVcsRUFBRSxDQUFDLENBQUMsTUFBTTtRQUNyQixZQUFZLEVBQUUsQ0FBQyxDQUFDLEtBQUssQ0FBQyxDQUFDLENBQUMsQ0FBQyxNQUFNLEVBQUUsQ0FBQyxDQUFDLElBQUksQ0FBQyxDQUFDO1FBQ3pDLElBQUksRUFBRSxDQUFDLENBQUMsTUFBTSxDQUFDLENBQUMsQ0FBQyxNQUFNLEVBQUUsQ0FBQyxDQUFDLEdBQUcsQ0FBQztRQUMvQixHQUFHLEVBQUUsQ0FBQyxDQUFDLE1BQU07S0FDZCxDQUFDO0lBQ0YsQ0FBQyxDQUFDLE9BQU8sQ0FBQztRQUNSLFVBQVUsRUFBRSxDQUFDLENBQUMsT0FBTztRQUNyQixPQUFPLEVBQUUsQ0FBQyxDQUFDLEtBQUssQ0FBQyxDQUFDLENBQUMsQ0FBQyxNQUFNLEVBQUUsQ0FBQyxDQUFDLElBQUksQ0FBQyxDQUFDO1FBQ3BDLFFBQVEsRUFBRSxDQUFDLENBQUMsTUFBTTtRQUNsQixPQUFPLEVBQUUsQ0FBQyxDQUFDLE1BQU07UUFDakIsT0FBTyxFQUFFLENBQUMsQ0FBQyxNQUFNO0tBQ2xCLENBQUM7Q0FDSCxFQUNELE9BQU8sQ0FDUixDQUFDO0FBRUYsTUFBTSxPQUFPLEtBQUs7O0FBQ0YsWUFBTSxHQUFHLFlBQVksQ0FBQyxNQUFNLEVBQUUsTUFBTSxFQUFFLFFBQVEsQ0FBQyxDQUFDIn0=